<template>
    <div v-if="activeStep >= step" class="section-header text-yanone">
        <h4 class="section-title no-border pb-0 mb-0">
            <h4 class="section-title no-border d-flex pb-0 mb-0">
                <div class="box-label mr-2">{{ stepNumber }}</div>
                <span class="text-uppercase">&nbsp;{{ title }}</span>
            </h4>
        </h4>
        <a
            v-if="allowChange"
            v-show="success"
            class="btn btn-light btn-sm mt-3"
            :class="{ 'hidden-xs-up': hideChangeDesktop }"
            @click="goToStep"
        >
            {{ $t('toChange') }}
        </a>
    </div>
</template>

<script>
    import store from '../../script/store/checkout';
    import { CHECKOUT_STEPS } from '../../script/store/checkout/consts';

    export default {
        name: 'CheckoutStepHeader',

        props: {
            title: String,
            step: Number,
            stepNumber: Number,
            activeStep: Number,
            allowChange: Boolean,
            success: Boolean,
            hideChangeDesktop: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                ...CHECKOUT_STEPS,
            };
        },

        methods: {
            goToStep() {
                store.step.goTo(this.step);
            },
        },
    };
</script>
